import * as React from 'react'
import { Descriptions, Skeleton } from 'antd'
import { FormattedMessage } from 'react-intl'
import { useRegisteredEmail } from './queries'
import { useOrganizationByName } from '../../queries'

type Props = {
  name?: string
  email?: string
}

const ShowCompanyInfo = ({ name }: Props) => {
  const organizationQuery = useOrganizationByName(name ?? '')
  const registeredEmailQuery = useRegisteredEmail(name ?? '')

  return (
    <Descriptions column={1}>
      <Descriptions.Item label={<FormattedMessage id="companyName" />}>
        {name}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage id="crNumber" />}>
        <Skeleton
          loading={organizationQuery.isLoading}
          active={organizationQuery.isLoading}
          title={false}
          paragraph={{ rows: 1 }}
        >
          {organizationQuery.data === 'Not Found' ||
          !organizationQuery.data ||
          !organizationQuery.data.crNumber ? (
            <FormattedMessage id="noCRNFound" />
          ) : (
            organizationQuery.data.crNumber
          )}
        </Skeleton>
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage id="address" />}>
        <Skeleton
          loading={registeredEmailQuery.isLoading}
          active={registeredEmailQuery.isLoading}
          title={false}
          paragraph={{ rows: 1 }}
        >
          {registeredEmailQuery.data?.email ?? (
            <FormattedMessage id="noAddressFound" />
          )}
        </Skeleton>
      </Descriptions.Item>
    </Descriptions>
  )
}

export default ShowCompanyInfo
